import { Component } from 'react'

export function getFullPath(windowLocation) {
  /**
   * Given a window.location object, it returns the full path of the URL without
   * the origin.
   *
   * https://example.com/test/?foo=1#bar would become /test/?foo=1#bar
   */
  return windowLocation.href.replace(windowLocation.origin, '')
}

class TrackPageview extends Component {
  static defaultProps = {
    isLoading: false,
    getPageviewData: undefined,
  }

  constructor(props) {
    super(props)
    this.state = { url: undefined }
  }

  static getDerivedStateFromProps(props, state) {
    /**
     * Sends a GA pageview event and includes contentGroup data for the
     * current page. This will only be triggered if `props.isLoading` is false,
     * that means, the View that passes in this prop has loaded data from
     * GraphQL and is now ready to compute the contentGroup data.
     */
    if (!!props.isLoading) {
      return null
    }

    if (typeof window !== 'undefined') {
      const currentURL = getFullPath(window.location)
      if (state.url !== currentURL) {
        let extraData = {
          contentGroup1: undefined,
          contentGroup2: undefined,
          contentGroup3: undefined,
          contentGroup4: undefined,
        }
        if (props.getPageviewData) {
          extraData = { ...extraData, ...props.getPageviewData() }
        }
        window.dataLayer.push({
          event: 'Pageview',
          url: currentURL,
          ...extraData,
        })
        return { url: currentURL }
      }
    }
    return null
  }

  render() {
    return null
  }
}

export default TrackPageview
